module.exports = __webpack_public_path__ + "img/light-ceiling.6142be31.svg";